import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { DatePipe } from "@angular/common";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSort, Sort, MatSortHeader } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { ConfirmationDialog } from "../incs/confirmation-dialog.component";
import { Pair } from "../../obj/Pair";
import { EntityBase } from "../../entity/EntityBase";
import { Utility } from "../../entity/Utility";
import { SellerContract } from "../../entity/SellerContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { SellerTermsContractDialogComponent } from "../incs/seller-terms-contract-dialog.component";
import { HeaderComponent } from "../incs/header.component";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "kilowant-seller-terms-list",
    templateUrl: "../../../html/seller/seller-terms-list.html",
    imports: [HeaderComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatSortHeader, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class SellerTermsListComponent extends AbstractSellerComponent {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    displayedColumns: string[] = ["#", "ContractId", "ContractName", "ContractHash", "TermRescission", "DateAdded", "DateUpdated", "Action"];
    dataSource: MatTableDataSource<SellerContract>;

    dialogRef: MatDialogRef<any> = null!;
    dropdownSettings: any = {};

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        this.generalService.getSellerContracts()
            .then(cs => {
                this.dataSource = new MatTableDataSource(cs);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.dataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                        case "ContractName": {
                            return item.name;
                        }
                        case "ContractId": {
                            return item.id;
                        }
                        case "DateAdded": {
                            return this.datepipe.transform(item.dateEntered, "yyyyMMdd") || "";
                        }
                        case "DateUpdated": {
                            return this.datepipe.transform(item.dateUpdated, "yyyyMMdd") || "";
                        }
                        default: {
                            return "";
                        }
                    }
                };
            });
        this.route.params.forEach((params: Params) => {
            let action: string = params["action"];
            if (action == "add") {
                this.addSellerContract();
            }
        });
    }

    reloadSellerContracts(): void {
        this.generalService.getSellerContracts()
            .then(cs => {
                this.dataSource.data = cs;
            });
    }

    addSellerContract(): void {
        this.dialogRef = this.dialog.open(SellerTermsContractDialogComponent, {
            disableClose: false
            , panelClass: "card-popup"
        });
        this.dialogRef.afterClosed().subscribe(result => {
            this.reloadSellerContracts();
            this.dialogRef = null!;
        });
    }

    editSellerContract(sellerContract: SellerContract): void {
        this.dialogRef = this.dialog.open(SellerTermsContractDialogComponent, {
            disableClose: false
            , panelClass: "card-popup"
        });
        this.dialogRef.componentInstance.setSellerContract(sellerContract);
        this.dialogRef.afterClosed().subscribe(result => {
            this.reloadSellerContracts();
            this.dialogRef = null!;
        });
    }

    copySellerContract(sellerContract: SellerContract): void {
        this.generalService.copySellerContract(sellerContract.id)
            .subscribe((res: any) => {
                this.reloadSellerContracts();
            },
                err => {
                });
    }

    deleteSellerContract(sellerContract: SellerContract): void {
        this.dialogRef = this.dialog.open(ConfirmationDialog, {
            disableClose: false
            , panelClass: "card-popup"
        });
        this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete this services agreement?"

        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.generalService.deleteSellerContract(sellerContract.id)
                    .subscribe((res: any) => {
                        this.reloadSellerContracts();
                    },
                        err => {
                        });
            }
            this.dialogRef = null!;
        });
    }
}